import {InjectionToken} from '@angular/core';

export interface MarkdownFiles {
  keys(): string[];

  (key: string): string;
}

export interface ComponentCatalogOptions {
  /**
   * Optional markdown files (otherwise they are taken from "docs" in the repository root).
   */
  markdownFiles?: MarkdownFiles;

  /**
   * Optional brand name.
   */
  brandTitle?: string;
}

export const OPTIONS = new InjectionToken<ComponentCatalogOptions>('ComponentCatalogOptions');
